<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 14:16:09
 * @LastEditors: 诺
 * @LastEditTime: 2022-01-13 21:25:55
 * @Description: file content
 -->
<template>
  <div class="btn_home act-text-stroke" :style="{ backgroundColor: bColor, color: textColor }" @click="$goPage(url || 'index', $route.query)">返回</div>
</template>

<script>
export default {
  components: {},
  props: ["bColor", "textColor", "url"],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="css" scoped>
.btn_home {
  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 100;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 24px;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_home > img {
  width: 100%;
  opacity: 0.9;
}
</style>
